import { useMemo } from "react";
import { useConfig } from "../providers/config_provider";

export function useChatUrl(query: string) {
  const { conversationContext } = useConfig();
  const { url } = conversationContext;

  return useMemo(() => `${url}?dewey_q=${encodeURIComponent(query)}`, [url, query]);
}
